import { useVersionState } from './useVersionQueries';
import { versionStateLabels } from './versionCopy';
export function VersionBadge({ version }: { version: string }) {
  const query = useVersionState(version);
  if (query.isPending) return <span role="status">Проверка версии…</span>;
  if (!query.isSuccess) return <span>Состояние версии недоступно</span>;
  return <span>{versionStateLabels[query.data.state]}</span>;
}
